// extracted by mini-css-extract-plugin
export var dropdownIcon = "_o7-6";
export var imgContainer = "_o7-3";
export var menuIcon = "_o7-5";
export var pillWrapper = "_o7-2";
export var pillsContainer = "_o7-1";
export var subscriptionCard = "_o7-0";
export var subscriptionLogo = "_o7-4";